/**
 * Shared formatting utilities used across multiple pages.
 * Extracted to eliminate duplicate function definitions.
 */

export function formatCurrency(value) {
  if (value === null || value === undefined || value === '') return '--';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatCompactCurrency(value) {
  if (value === null || value === undefined) return '--';
  if (Math.abs(value) >= 1000000000) return '$' + (value / 1000000000).toFixed(2) + 'B';
  if (Math.abs(value) >= 1000000) return '$' + (value / 1000000).toFixed(1) + 'M';
  if (Math.abs(value) >= 1000) return '$' + (value / 1000).toFixed(0) + 'K';
  return '$' + value.toLocaleString();
}

export function formatDate(dateStr) {
  if (!dateStr) return '--';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
